import { OrderLineType } from './order-line-type';
import { environment } from '../../../../environments/environment';
import { Partner } from '../../partner/models/partner';
import { Product } from './product';

export class OrderLine {
  id: number;
  productId: number;
  name: string;
  price: number;
  taxRate: number;
  quantity: number;
  readonly: boolean;
  orderLineType: OrderLineType;
  rfid_card_ean13: string;
  bookingSlotId: number;
  coupon: string;
  categoryId: number;
  categoryName: number;
  partners: Partner[];
  groupSize: number;
  eventDateStart: Date;
  eventDateEnd: Date;
  pickupPointId: number;
  pickupPointName: string;
  pickupPointGroupName: string;
  pickupPointGroupId: number;
  bookingDate: Date;
  isStockProduct: boolean;

  product: Product;

  constructor(
    id: number,
    productId: number,
    name: string,
    price: number,
    taxRate: number,
    quantity: number,
    readonly: boolean,
    orderLineType: OrderLineType,
    bookingSlotId: number,
    rfid_card_ean13?: string,
    coupon?: string,
    categoryId?: number,
    categoryName?: number,
    partners?: Partner[],
    groupSize?: number,
    eventDateStart?: Date,
    eventDateEnd?: Date,
    pickupPointId?: number,
    pickupPointName?: string,
    pickupPointGroupName?: string,
    pickupPointGroupId?: number,
    bookingDate?: Date,
    isStockProduct?: boolean,
  ) {
    this.id = id;
    this.productId = productId;
    this.name = name;
    this.price = price;
    this.taxRate = taxRate;
    this.quantity = quantity;
    this.readonly = readonly;
    this.orderLineType = orderLineType;
    this.bookingSlotId = bookingSlotId;
    this.rfid_card_ean13 = rfid_card_ean13;
    this.coupon = coupon;
    this.categoryId = categoryId;
    this.categoryName = categoryName;
    this.partners = partners;
    this.groupSize = groupSize;
    this.eventDateStart = eventDateStart;
    this.eventDateEnd = eventDateEnd;
    this.pickupPointId = pickupPointId;
    this.pickupPointName = pickupPointName;
    this.pickupPointGroupName = pickupPointGroupName;
    this.pickupPointGroupId = pickupPointGroupId;
    this.bookingDate = bookingDate;
    this.isStockProduct = isStockProduct;
  }

  static createFromAny(object: any): OrderLine {
    if (object === null || object === undefined) {
      return null;
    }

    return new OrderLine(
      object.id,
      object.productId,
      object.name,
      object.price,
      object.taxRate,
      object.quantity,
      object.readonly,
      object.orderLineType,
      object.bookingSlotId,
      object.rfid_card_ean13,
      object.coupon,
      object.categoryId,
      object.categoryName,
      object.partners ? object.partners.map(x => Partner.createFromAny(x)) : new Array<Partner>(),
      object.groupSize,
      object.eventDateStart ? new Date(object.eventDateStart) : null,
      object.eventDateEnd ? new Date(object.eventDateEnd) : null,
      object.pickupPointId,
      object.pickupPointName,
      object.pickupPointGroupName,
      object.pickupPointGroupId,
      object.bookingDate ? new Date(object.bookingDate) : null,
      object.isStockProduct,
    );
  }

  get amount(): number {
    return this.price * this.quantity;
  }

  get tax(): number {
    const amount = this.amount;
    return amount - amount / (1 + 1 * this.taxRate);
  }

  copy(): OrderLine {
    return new OrderLine(
      -1,
      this.productId,
      this.name,
      this.price,
      this.taxRate,
      this.quantity,
      this.readonly,
      this.orderLineType,
      this.bookingSlotId,
      this.rfid_card_ean13,
      this.coupon,
      this.categoryId,
      this.categoryName,
      this.partners,
      this.groupSize,
      this.eventDateStart,
      this.eventDateEnd,
      this.pickupPointId,
      this.pickupPointName,
      this.pickupPointGroupName,
      this.pickupPointGroupId,
      this.bookingDate,
      this.isStockProduct,
    );
  }

  isOfType(...params: OrderLineType[]): boolean {
    params = params ? params : [];
    return params.indexOf(this.orderLineType) > -1;
  }

  get quantityString(): string {
    return this.quantity.toString();
  }

  set quantityString(value) {
    this.quantity = parseInt(value, 10);
  }

  toJSON(): any {
    return {
      id: this.id,
      name: this.name,
      productId: this.productId,
      price: this.price,
      quantity: this.quantity,
      taxRate: this.taxRate,
      orderLineType: this.orderLineType,
      rfid_card_ean13: this.rfid_card_ean13,
      bookingSlotId: this.bookingSlotId,
      readonly: this.readonly,
      coupon: this.coupon,
      categoryId: this.categoryId,
      categoryName: this.categoryName,
      partners: this.partners,
      groupSize: this.groupSize,
      eventDateStart: this.eventDateStart,
      eventDateEnd: this.eventDateEnd,
      pickupPointId: this.pickupPointId,
      pickupPointName: this.pickupPointName,
      pickupPointGroupId: this.pickupPointGroupId,
      pickupPointGroupName: this.pickupPointGroupName,
      bookingDate: this.bookingDate ? environment.globalSettings.getIsoDateStr(this.bookingDate.getFullYear(), this.bookingDate.getMonth() + 1, this.bookingDate.getDate()) : this.bookingDate,
      isStockProduct: this.isStockProduct,
    };
  }
}
